import { commonFunctions } from "../_utilities/commonFunctions"
import { config } from "../config";

export const clientService = {
    createClientAddress
}

function createClientAddress(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    }
    const requestOptions = commonFunctions.getRequestOptions(
        "POST",
        extraHeaders,
        JSON.stringify(data)
    );
    return fetch (
        `${config.localApiUrl}/api/createClientCard`,
        requestOptions
    ).then((response) => response.json())
}